<ng-container *ngIf="userList === null; else userDetaills">
  <div class="no-appoint-message">
    <div>No Data Found!</div>
  </div>
</ng-container>

<ng-template #userDetaills>
  <app-table *ngIf="userList"
            [dataSource]="dataSource"
            [columnDefinition]="displayedColumns"
            [showFilter]="true"
            [pageSize]="2000">
  </app-table>
</ng-template>

<ng-template #contactColumn
            let-item="item">
            <div class="contact-container">
              <span>{{item.split(':')[1]}}</span>
              <a [href]="item">
                <app-icon [item]="phoneIcon">
                </app-icon>
              </a>
            </div>
</ng-template>

<ng-template #emailColumn
            let-item="item">
            <div class="contact-container">
              <span>{{item.split(':')[1]}}</span>
              <a [href]="item">
                <app-icon [item]="editIcon">
                </app-icon>
              </a>
            </div>
</ng-template>